import { render, staticRenderFns } from "./OffendingPrefixes.vue?vue&type=template&id=22618a4f&scoped=true&"
import script from "./OffendingPrefixes.vue?vue&type=script&lang=js&"
export * from "./OffendingPrefixes.vue?vue&type=script&lang=js&"
import style0 from "./OffendingPrefixes.vue?vue&type=style&index=0&id=22618a4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22618a4f",
  null
  
)

export default component.exports